<template>
  <div>
    <CCard class="px-3">
      <CCardBody>
        <CRow
          class="
            justify-content-between
            align-items-start
            mb-2
            flex-column
            px-2
            mb-3
          "
        >
          <div class="d-flex align-items-center">
            <figure v-if="marketHaveLogo(market)" class="m-0 mr-3">
              <img
                :src="marketLogoThumb(market)"
                alt=""
                class="border-0 rounded-circle"
                width="64"
                height="64"
              />
            </figure>

            <div
              class="d-flex flex-column align-items-start align-items-md-center"
            >
              <span class="d-inline-block ui-type-display-lg mr-3">{{
                marketName(market)
              }}</span>
            </div>
          </div>
        </CRow>
        <CRow
          class="
            justify-content-between
            align-items-start
            flex-column
            px-2
            my-3
          "
        >
          <div class="w-100">
            <div
              class="
                d-flex
                flex-column flex-md-row
                align-items-start
                justify-content-start
                mt-1
              "
            >
              <span
                class="badge badge-success mr-2 my-2 my-md-0 py-1 px-2"
                v-if="showDelivery(market)"
              >
                <font-awesome-icon icon="truck" />
                {{ $t("family.market.box.delivery") }}</span
              >
              <span
                class="badge badge-success my-2 my-md-0 py-1 px-2"
                v-if="showPickup(market)"
              >
                <font-awesome-icon icon="store" />
                {{ $t("family.market.box.pickup") }}</span
              >
              <span
                class="badge badge-gray-200 my-2 my-md-0 py-1 px-2 ml-2"
                v-if="market.cart"
              >
                <font-awesome-icon icon="shopping-cart" />
                {{ market.cart.view.n_items }}
                {{ $t("family.market.box.productsInCart") }}</span
              >
            </div>
          </div>
        </CRow>

        <CRow
          v-if="market.market.role.desc_zone"
          class="
            justify-content-between
            align-items-start
            flex-column
            px-2
            my-3
          "
        >
          <div class="ui-card-product__title mb-1">
            {{ $t("family.market.box.marketDescription") }}:
          </div>

          <div class="" v-html="market.market.role.desc_short"></div>
        </CRow>

        <CRow
          v-if="market.market.role.desc_zone"
          class="
            justify-content-between
            align-items-start
            mb-3
            flex-column
            px-2
          "
        >
          <div class="ui-card-product__title mb-1">
            {{ $t("family.market.box.marketRegion") }}:
          </div>

          <div class="">{{ market.market.role.desc_zone }}</div>
        </CRow>

        <CRow
          class="
            justify-content-between
            align-items-start
            mb-3
            flex-column
            px-2
          "
        >
          <div class="ui-card-product__title mb-1">
            {{ $t("family.market.box.marketProducers") }}:
          </div>
          <div>
            <span
              v-for="(producer, index) in producers"
              @click="showProducerProfile(producer)"
              :key="`producer-${index}`"
              class="badge badge-light py-1 px-2 mr-2 mb-1 producer-badge"
            >
              {{ producer.role.name }}
            </span>
          </div>
        </CRow>

        <CRow
          class="
            justify-content-between
            align-items-start
            mb-3
            flex-column
            px-2
          "
        >
          <div class="bg-gray-100 rounded p-3 w-100 text-dark">
            <div class="ui-card-product__title">
              {{ $t("family.market.box.marketEvents") }}:
            </div>

            <CCallout color="primary border-0 pl-1 mt-2 mb-0">
              <font-awesome-icon icon="clock" class="mr-2 text-primary" />
              <span v-if="timelimitToOrder(market, $i18n.locale)"
                >{{ $t("family.market.box.marketEventsClosure") }}
                {{ timelimitToOrder(market, $i18n.locale) }}</span
              ></CCallout
            >
            <CCallout color="primary border-0 pl-1 mt-2 mb-2">
              <font-awesome-icon icon="truck" class="mr-2 text-primary" />
              <span v-if="showDelivery(market)"
                >{{ $t("family.market.showcase.delivery") }}
                <strong>{{ deliveryDate(market) }}</strong></span
              >
              <span v-if="showPickup(market)"
                >{{ $t("family.market.showcase.pickup") }}
                <strong>{{ pickupDate(market) }}</strong></span
              ></CCallout
            >
          </div>
        </CRow>

        <CRow
          class="justify-content-start align-items-center mb-2 flex-row px-2"
        >
          <CButton
            color="primary"
            @click="openMarket(market)"
            class="text-uppercase"
            >{{ $t("family.market.box.btn") }}</CButton
          >
          <!--
          <CButton color="secondary" class="text-uppercase ml-2"
            >Request access</CButton
          >-->
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      :show.sync="producerModalVisible"
      :closeOnBackdrop="true"
      :centered="true"
      size="xl"
      class="producer-modal"
    >
      <template v-if="producerModalVisible">
        <MarketProducerProfile
          :producer="producerModal"
          :market="market.market"
          @close="producerModalVisible = false"
        />
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import marketMixin from "../../../mixins/market";
import { apiGetRQL } from "../../../helpers/apiHelper";
import MarketProducerProfile from "./MarketProducerProfile.vue";
import get from "lodash/get";

export default {
  name: "MarketBoxNew",

  mixins: [marketMixin],

  components: {
    MarketProducerProfile,
  },

  props: {
    market: { type: Object, required: true },
  },

  data() {
    return {
      loading: true,
      products: [],
      producers: [],
      producerModal: {},
      producerModalVisible: false,
    };
  },

  mounted() {
    this.getProducers();
  },

  computed: {
    producerModalTitle() {
      return get(this.producerModal, "role.name", "Producer Profile");
    },

    user_lang() {
      return this.$i18n.locale;
    },
    ...mapGetters("connections", ["currencySymbol", "familyId"]),
  },

  methods: {
    openMarket(market) {
      this.$store.commit("shop/setMarket", market);
      this.$store.commit("shop/setCart", {});
      this.$router.push({
        name: "UserMarketDetail",
        params: { familyId: this.familyId, marketId: market.market.id },
      });
    },

    async getProducers() {
      let params = {
        endpoint: "family_market_producers",
        params: [
          this.$store.state.connections.current.family.id,
          this.market.market.id,
        ],
        filter: {},
      };

      const response = await apiGetRQL(params);

      if (response && response.data) {
        this.loading = false;
        this.producers = response.data.payload.Items;
      }
    },

    showProducerProfile(producer) {
      this.producerModal = producer;
      this.producerModalVisible = true;
    },
  },
};
</script>
